export const candidateLocationLabel = candidate => [candidate?.city, candidate?.state]
  .map(value => String(value ?? "").trim()).filter(Boolean).join(", ");

export const hasUsableCandidateCoordinates = candidate => {
  const precision = candidate?.locationPrecision ?? candidate?.location_precision;
  if (precision != null && !["city", "address"].includes(precision)) return false;
  const lat = candidate?.lat;
  const lng = candidate?.lng;
  if ([lat, lng].some(value => value == null || typeof value === "boolean" || String(value).trim() === "")) return false;
  return Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))
    && Math.abs(Number(lat)) <= 90 && Math.abs(Number(lng)) <= 180;
};

export const hasCandidateLocationInformation = candidate => String(candidate?.state ?? "").trim() !== "" || hasUsableCandidateCoordinates(candidate);
